import { render, staticRenderFns } from "./project-libs.vue?vue&type=template&id=3b5d8b75"
import script from "./project-libs.vue?vue&type=script&lang=js"
export * from "./project-libs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports